import axios from 'axios'
// @ts-ignore
import * as QueryParams from '@waze/george/lib/query-params'

export const getParamsWithPrefix = (prefix: string): { [key: string]: any } => {
  const params: { [key: string]: any } = {}
  const allParams = QueryParams.all()
  const regex = new RegExp(`^${prefix}`)

  Object.keys(allParams)
    .filter(name => name.match(regex))
    .forEach(name => {
      params[name.replace(prefix, '')] = allParams[name]
    })

  return params
}

export interface IRedirectOptions {
  replace?: boolean
}

export const redirect = (url: string, options: IRedirectOptions = {}): void => {
  if (QueryParams.get('skipRedirect')) {
    console.info(`Skipped redirect to '${url}'`)
  } else {
    if (options.replace && window.location.replace != null) {
      window.location.replace(url)
    } else {
      window.location.href = url
    }
  }
}

export const getCurrentPath = (): string => window.location.pathname
export const getCurrentPathWithQuery = (): string =>
  window.location.pathname + window.location.search

/**
 * Joins two parts of a path, properly handling the '/' between them.
 * E.g. joinPath('a/', 'b') === joinPath('a', 'b').
 */
export const joinPaths = (part1: string, part2: string): string =>
  part1 + (part1.endsWith('/') ? '' : '/') + part2

export const getIntegerQueryParam = (paramName: string, defaultValue = 0): number => {
  const value = QueryParams.get(paramName)
  return /^\d+$/.test(value) ? parseInt(value, 10) : defaultValue
}

export const get = (url: string): Promise<any> => {
  return axios.get(url).then(response => response.data)
}

export const post = (url: string, data: { [key: string]: any }): Promise<any> => {
  return axios.post(url, data).then(response => response.data)
}

export default {
  getParamsWithPrefix,
  redirect,
  getCurrentPath,
  getCurrentPathWithQuery,
  getIntegerQueryParam,
  get,
  post
}
